import React, { useEffect, useState } from 'react';
import './LandingPage.css';
import { useNavigate } from 'react-router-dom';
import { FaApple, FaGooglePlay } from 'react-icons/fa';

const heroBackdrop = '/images/img1/thomas-serer-alUSb8lCE5s-unsplash.jpg';
const heroIllustration = '/images/img1/rival.jpg';
const innovationBackdrop = '/images/img1/fans.jpg';
const featuredRivalryImage = '/images/img1/clark-tibbs-oqStl2L5oxI-unsplash.jpg';
const plusOneCardImage = '/images/img1/rival.jpg';
const contentTamperImage = '/images/img1/contentTamper.jpg';
const envGuardImage = '/images/img1/enguard.jpg';

const getInitialLiveRequests = () => 12000 + Math.floor(Math.random() * 1200);
const formatLiveRequests = (count) => {
  if (count >= 1000) {
    const abbreviated = (count / 1000).toFixed(1);
    return abbreviated.endsWith('.0') ? `${Math.round(count / 1000)}k` : `${abbreviated}k`;
  }
  return count.toLocaleString();
};

const LandingPage = () => {
  const navigate = useNavigate();
  const [requestingChallengeCount, setRequestingChallengeCount] = useState(getInitialLiveRequests);

  useEffect(() => {
    const interval = setInterval(() => {
      setRequestingChallengeCount((prev) => prev + Math.floor(Math.random() * 80) + 15);
    }, 2200);

    return () => clearInterval(interval);
  }, []);

  const formattedRequests = formatLiveRequests(requestingChallengeCount);

  return (
    <>
      <section
        className="hero-section"
        style={{
          backgroundImage: `linear-gradient(120deg, rgba(10,14,45,0.95), rgba(14,21,61,0.85)), url(${heroBackdrop})`,
        }}
      >
        <div className="hero-container">
          <div className="hero-content">
            <p className="hero-eyebrow">Realtime innovation studio</p>
            <h1>MEANC – Modern Software &amp; Cloud Innovation</h1>
            <p className="hero-subtitle">
              We build real-time fan platforms, secure content tech, 
              and modern cloud tools—powering rivalries, protecting creators, and supporting developers.
            </p>

            <div className="hero-tags">
              <span>Realtime video</span>
              <span>Zero-trust content</span>
              <span>Recruiter + athlete cloud</span>
            </div>

            <div className="hero-cta">
              <button className="cta-btn" onClick={() => navigate('/access-lab')}>
                Launch Console
              </button>
              <button className="cta-btn-secondary" onClick={() => navigate('/sign')}>
                Login / Register
              </button>
            </div>
            <div className="hero-store-row">
              <button className="store-pill">
                <FaApple />
                <span>App Store</span>
              </button>
              <button className="store-pill">
                <FaGooglePlay />
                <span>Google Play</span>
              </button>
            </div>
          </div>

          <div className="hero-visual">
            <img src={heroIllustration} alt="Product illustration showing dashboards" />
            <div className="hero-card">
              <p className="hero-card-label">Featured launch</p>
              <h3>RivalCam App</h3>
              <p className="hero-card-text">
                Two fans face off. One Trophy Cam settles it.
                RivalCam keeps the challenge fair and shows the live score instantly.
              </p>
              <button className="project-button" onClick={() => navigate('/sign')}>
                View case study
              </button>
              <div className="hero-live-card">
                <div className="hero-live-label">
                  <span className="live-dot" />
                  Requesting Challenge
                </div>
                <p className="hero-live-value">
                  {formattedRequests} fans are pinging rival rooms
                </p>
                <p className="hero-live-subline">rival requests climbing every few seconds</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="featured-app">
        <div className="featured-media">
          <img src={featuredRivalryImage} alt="ChallengeRivalry stadium atmosphere" />
          <div className="featured-badge">Top app • RivalCam</div>
        </div>
        <div className="featured-content">
          <p className="hero-eyebrow">Flagship experience</p>
          <h2>RivalCam powers college sports fandom</h2>
          <p>
            Our flagship mobile experience lets rival crowds capture highlight angles, sync reactions, and pull a
            digital trophy toward their campus in seconds.
          </p>
          <ul className="featured-list">
            <li>Instant rivalry rooms with motion graphic leaderboards</li>
            <li>Edge-streamed highlights with tamper-aware verification</li>
            <li>Recruiter + athlete cloud workspace with white-glove curation</li>
          </ul>
          <div className="hero-cta">
            <button className="cta-btn" onClick={() => navigate('/access-lab')}>
              Request early access
            </button>
            <button className="cta-btn-secondary" onClick={() => navigate('/conversations')}>
              See fan beta reels
            </button>
          </div>
          <div className="store-badges featured-badges">
            <button className="store-pill">
                <FaApple />
                <span>App Store</span>
              </button>
              <button className="store-pill">
                <FaGooglePlay />
                <span>Google Play</span>
              </button>
          </div>
        </div>
      </section>
      <section
        className="innovation-banner"
        style={{
          backgroundImage: `linear-gradient(135deg, rgba(7,11,40,0.85), rgba(12,22,64,0.7)), url(${innovationBackdrop})`,
        }}
      >
        <div className="banner-text">
          <p className="hero-eyebrow">Coming soon</p>
          <h2>Security storytelling with ContentTamper</h2>
          <p>
            We are polishing an illustrated security layer that keeps creators in control of their footage from the
            first upload through verified handoff.
          </p>
          <div className="hero-cta">
            <button className="cta-btn" onClick={() => navigate('/contact')}>
              Join the waitlist
            </button>
            <button className="cta-btn-secondary" onClick={() => navigate('/envguard')}>
              See platform highlights
            </button>
          </div>
        </div>
      </section>
      

      <section className="projects-section">
        <h2 className="section-title">Explore Our Products</h2>
        <p className="section-subtitle">
          Each launch blends cinematic design, measurable performance, and illustrated storytelling so partners
          instantly understand the value.
        </p>

        <div className="project-grid">
          <div className="project-card highlight">
            <figure className="project-figure">
              <img src={plusOneCardImage} className="project-image" alt="College sports fans" />
            </figure>
            <span className="badge-coming-soon">Fan duel mode</span>
            <h3>RivalCam</h3>
            <p>
              Fans film live reactions on their phones while tugging the shared trophy toward their campus. Simple,
              fair scoring—no imaginary stats.
            </p>
            <div className="store-badges">
              <button className="store-pill2">
                <FaApple />
                <span>App Store</span>
              </button>
              <button className="store-pill2">
                <FaGooglePlay />
                <span>Google Play</span>
              </button>
            </div>
            
          </div>

          <div className="project-card">
            <figure className="project-figure">
              <img src={contentTamperImage} className="project-image" alt="Secure workflows" />
            </figure>
            <h3>ContentTamper</h3>
              <p>
                A creator-first workspace for locking down files, confirming who accessed what, and exporting proof
                without leaving the editing desk.
              </p>
            <button className="project-button" onClick={() => navigate('/contenttamper')}>
              Explore features
            </button>
          </div>

          <div className="project-card">
            <figure className="project-figure">
              <img src={envGuardImage} className="project-image" alt="Developers collaborating" />
            </figure>
            <h3>EnvGuard</h3>
              <p>
                A calm internet-security dashboard where teams rotate secrets, monitor API usage, and confirm nothing
                sensitive leaks between projects.
              </p>
            <button className="project-button" onClick={() => navigate('/envguard')}>
              View documentation
            </button>
          </div>
        </div>
      </section>

      <section className="about-company">
        <div className="about-content">
          <h2 className="section-title">About MEANC</h2>
          <p className="about-text">
            MEANC is a modern software studio dedicated to stadium-ready fan engagement, verifiable content
            protection, and developer-grade security ops. Products like RivalCam, ContentTamper, and EnvGuard
            combine expressive visuals with rigorous engineering so partners see value the moment they log in.
          </p>
          <div className="values-grid">
            <div className="value-box">
              <h4>⚡ Performance</h4>
              <p>Realtime pipelines tuned for milliseconds.</p>
            </div>
            <div className="value-box">
              <h4>🔐 Security</h4>
              <p>Zero-trust content protection across every upload.</p>
            </div>
            <div className="value-box">
              <h4>🎨 Storytelling</h4>
              <p>Design-forward launches with immersive illustrations.</p>
            </div>
          </div>
        </div>
        <div className="about-illustration">
          <img
            src="https://images.unsplash.com/photo-1487014679447-9f8336841d58?auto=format&fit=crop&w=1200&q=80"
            alt="Design team collaborating"
          />
        </div>
      </section>

      <footer className="footer">
         {/* <div className="footer-links">
          <a href="/terms">Terms</a>
          <a href="/privacy">Privacy</a>
          <a href="/contact">Contact</a>
        </div> 
        <p>© 2025 MEANC Technologies – All Rights Reserved</p> */}
      </footer>
    </>
  );
};

export default LandingPage;
